import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import CommonTextarea from '../../../../../../../components/common-textarea/CommonTextarea';
import CommonButton from '../../../../../../../components/common-button/CommonButton';
import { useProject } from '../../../../../../../context/ProjectContext';

import scss from './EditablePreview.module.scss';

function EditablePreview({ contentId, preview }) {
  const { t } = useTranslation('story');
  const { actions } = useProject();

  const [localText, setLocalText] = useState(preview ?? '');
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) {
      setLocalText(preview ?? '');
    }
  }, [preview, isEditing]);

  const handleStartEdit = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    const trimmedText = localText.trim();

    if (trimmedText !== (preview ?? '')) {
      actions('changePreview', { id: contentId, preview: trimmedText });
    }

    setLocalText(trimmedText);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setLocalText(preview ?? '');
    setIsEditing(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      handleCancel();
    }
  };

  if (isEditing) {
    return (
      <div className={scss.wrapper}>
        <CommonTextarea
          value={localText}
          onChange={setLocalText}
          onKeyDown={handleKeyDown}
          rows={3}
          autoFocus
          extraInputClass={scss.textarea}
        />

        <div className={scss.actions}>
          <CommonButton styleColor='secondary' className={scss.actionButton} onClick={handleCancel} size='sm'>
            {t('discard')}
          </CommonButton>

          <CommonButton styleColor='primary' className={scss.actionButton} onClick={handleSave} size='sm'>
            {t('saveChanges')}
          </CommonButton>
        </div>
      </div>
    );
  }

  return (
    <button type='button' className={clsx(scss.readView)} onClick={handleStartEdit} aria-label={t('editPreview')}>
      <span className={clsx(scss.text, !localText && scss.placeholder)}>{localText}</span>
      <EditOutlinedIcon className={scss.editIcon} aria-hidden />
    </button>
  );
}

export default EditablePreview;
